/**
 * BIN Block List — Universal Database (Qatar & International)
 */

export const BIN_BLOCK_LIST = {
  Qatar_And_Gulf: [
    "440671", "440672", "440673", "440674",
    "543357", "543358",
    "968201", "968202", "968203",
    "539012", "539013", "539014",
    "462220", "431943",
    "484783", "484784",
    "468540", "468541", "468542",
    "521076", "446404", "440795",
    "407197", "406136",
    "420132", "489022", "490980", "401978", "410834", 
    "415047", "454845", "461777", "512475",
    "403024", "403025", "403026",
    "510040", "510041", "510042",
    "458900", "458901", "458902",
    "542418", "542419", "542420",
  ],

  International_Virtual: [
    // Revolut
    "535522", "535523", "535524",
    "537310", "537311",
    "516344",
    // Wise (TransferWise)
    "526691", "526692",
    // Monzo
    "535420", "535421",
    // N26
    "533110", "533111",
    // Payoneer
    "516338",
    // Paysera
    "516616",
    // QIWI & YooMoney
    "489049", "469395", "518901",
    // Tinkoff / Kaspi / PayPal
    "437773", "440563", "418026"
  ]
};
